import IdentifiableDto from 'modules/base/dto/IdentifiableDto';

export class EsetleirasDto extends IdentifiableDto {
	constructor() {
		super();
		this.nev = null;
        this.csorszam = null;
		this.feladatCsoport = null;
    }

	setup(props) {
		super.setup(props);
        this.nev = props.nev;
        this.csorszam = props.csorszam;
		this.feladatCsoport = props.feladatCsoport;
		// this.roles = ['Admin'];
		return this;
	}

	getAsString(key) {
		if (key === 'feladatCsoport') {
			return this.feladatCsoport != null ? this.feladatCsoport.name : ''
		}
		return super.getAsString(key);
	}
}

export default EsetleirasDto;